module.exports = __webpack_public_path__ + "img/Hunter-nightelf-f-70.4fe10aa3.gif";